export default "__VITE_ASSET__e7f639d0__"